/**
 * [INPUT]: 依赖 index.css 暴露的 Laper CMS 语义色、圆角、阴影、金属按钮与 motion 同源 easing CSS variables
 * [OUTPUT]: 对外提供统一控件尺寸、抬升材质、浮层、菜单、遮罩和动效的共享视觉契约 class 常量
 * [POS]: zinnercms-design-system/ui 的视觉语法底座，以 32px 默认高度和同源物理阴影约束所有 primitive
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */

const focusRing = [
  "outline-none",
  "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30",
  "aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20",
].join(" ")

const controlSizes = Object.freeze({
  default: "h-8",
  sm: "h-8",
  lg: "h-10",
  icon: "size-8",
  iconSm: "size-8",
  iconLg: "size-10",
})

const raisedControlSurface = [
  "border border-input bg-background shadow-[var(--zncms-control-shadow)]",
  "hover:bg-card hover:shadow-[var(--zncms-control-shadow-hover)]",
  "active:brightness-95 active:shadow-[var(--zncms-control-shadow-pressed)]",
].join(" ")

const controlSurface = [
  "border border-input bg-background text-foreground shadow-xs",
  "rounded-md transition-[border-color,box-shadow,background-color,color,transform] duration-150 ease-snap",
  "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-45",
  focusRing,
].join(" ")

const floatingSurface = [
  "border border-border bg-popover text-popover-foreground shadow-lg",
  "rounded-xl",
].join(" ")

const menuMotion = [
  "data-[state=open]:animate-in data-[state=closed]:animate-out",
  "data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0",
  "data-[state=open]:zoom-in-95 data-[state=closed]:zoom-out-95",
  "data-[side=bottom]:slide-in-from-top-1 data-[side=left]:slide-in-from-right-1",
  "data-[side=right]:slide-in-from-left-1 data-[side=top]:slide-in-from-bottom-1",
  "duration-150 ease-settle",
].join(" ")

const dialogMotion = [
  "data-[state=open]:animate-in data-[state=closed]:animate-out",
  "data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0",
  "data-[state=open]:zoom-in-[0.985] data-[state=closed]:zoom-out-[0.985]",
  "duration-200 ease-drawer",
].join(" ")

const menuItem = [
  "relative flex min-h-8 cursor-default select-none items-center gap-2 rounded-md px-2.5 py-1.5",
  "text-[13px] outline-none transition-colors",
  "focus:bg-accent focus:text-accent-foreground data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground",
  "data-[disabled]:pointer-events-none data-[disabled]:opacity-40",
  "[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
].join(" ")

const overlayScrim = [
  "fixed inset-0 z-50 bg-[var(--zncms-overlay)] backdrop-blur-[2px]",
  "data-[state=open]:animate-in data-[state=closed]:animate-out",
  "data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0 duration-200 ease-out",
].join(" ")

const iconButton = [
  `inline-flex ${controlSizes.icon} items-center justify-center rounded-md text-muted-foreground`,
  "transition-[filter,background-color,border-color,color,box-shadow] duration-200 ease-settle",
  raisedControlSurface,
  focusRing,
].join(" ")

export {
  controlSurface,
  controlSizes,
  dialogMotion,
  floatingSurface,
  focusRing,
  iconButton,
  menuItem,
  menuMotion,
  overlayScrim,
  raisedControlSurface,
}
